import { FC } from "react";
import { Box, Typography } from "@mui/material";

import InputField from "../../../../common/Form/Input/InputField";
import FileUploadButton from "../../../../common/Form/FileUpload/FileUploadButton";
import { DATE_OF_CERTIFICATION, GCP_CERTIFICATE_1, GCP_CERTIFICATE_2, NEXT_GCP_CERTIFICATE_DUE_ON, VALID_UPTO } from "../../../../../constants/forms";

const GoodClinicalPractices: FC = (): JSX.Element => {
  return (
    <>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20">
          4.1 GCP Certification{" "}
          <Typography
            variant={"subtitle1"}
            component={"span"}
            color={"secondary"}
          >
            (Current & Previous document)
          </Typography>
        </label>
        <Box className="d-flex align-items-center gap-xs">
          <FileUploadButton
            name={GCP_CERTIFICATE_1}
            label="Upload  GCP certification 1"
            className="mg-t-0"
            tooltipTitle="Signed Confidentiality Agreement"
          />

          <FileUploadButton
            name={GCP_CERTIFICATE_2}
            label="Upload  GCP certification 2"
            className="mg-t-0"
            tooltipTitle="Signed Confidentiality Agreement"
          />

          <Typography
            variant={"subtitle1"}
            component={"span"}
            color={"secondary"}
          >
            (if applicable)
          </Typography>
        </Box>
      </Box>

      <InputField
        label={"4.2  Date of Certification"}
        name={DATE_OF_CERTIFICATION}
        placeholder={"Date of certification"}
        type="date"
      />

      <InputField
        label={"4.3  Valid upto"}
        name={VALID_UPTO}
        placeholder={"Valid upto"}
        type="date"
      />

      <InputField
        label={"4.4  Next GCP certification due on"}
        name={NEXT_GCP_CERTIFICATE_DUE_ON}
        placeholder={"Next GCP certification due on"}
        type="date"
      />
    </>
  );
};

export default GoodClinicalPractices;
